module.exports = __webpack_public_path__ + "static/media/country_np.def6bbdc.webp";